/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import { Popover, PopoverBody, PopoverHeader, Button } from "reactstrap";
import {
  bgImages,
  getBackgroundImages,
  selectBackgroundImg,
  selectBackgroundImgtoAdd,
  selectedColor,
} from "../../Redux/uploadFile/UploadFileSLice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const BackgroundPopover = ({ popoverId, buttonLabel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const imgInputRef = useRef(null);
  const colorToAdd = useSelector(selectedColor);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageURL, setSelectedImageURL] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };
  const images = useSelector(bgImages);
  useEffect(() => {
    dispatch(selectBackgroundImg(selectedImage));
    setSelectedImage(selectedImage);
  }, [dispatch, selectedImage]);

  useEffect(() => {
    dispatch(getBackgroundImages());
  }, [dispatch]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(selectBackgroundImgtoAdd(file));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleButtonClick = () => {
    imgInputRef.current.click();
  };

  const handleDone = async () => {
    setPopoverOpen(false);
  };
  const handleCancel = () => {
    setImagePreview(null);
  };

  const handleReset = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };
  return (
    <>
      <div className="customBox" id="backgroundPopover" onClick={togglePopover} data-text={t('addBackgroundPage.buttons.background')} // Ajout de l'attribut data-text
      >
        <div>
          <Button className="customActionButton select-img-add-bg-btn">
            {colorToAdd ? (
              <img
                src={"/images/AddBG/Picture Sun.svg"}
                className={"buttonIcon"}
                alt="background image"
              />
            ) : (
              <img
                src={
                  selectedImageURL
                    ? selectedImageURL
                    : "/images/AddBG/Picture Sun.svg"
                }
                className={
                  selectedImageURL
                    ? "selected-img-add-bg buttonIcon"
                    : "buttonIcon"
                }
                alt="background preview"
              />
            )}
          </Button>
        </div>
        <div>
          <label id={popoverId}>{buttonLabel}</label>
        </div>{" "}
      </div>
      <Popover
        placement="bottom"
        isOpen={popoverOpen}
        target={"backgroundPopover"}
        trigger="legacy"
        toggle={togglePopover}
        
      >
        <PopoverHeader>{t('addBackgroundPage.tooltips.selectBackground')}</PopoverHeader>
        <PopoverBody>
          <div className="backgroundOptions">
            <div
              className="colorBox"
              style={{ position: "relative" ,cursor:'pointer' }}
              onClick={handleReset}
            >
              <img
                src="/images/AddBG/emptyImg.svg"
                alt="empty"
                style={{ position: "absolute", top: "25%", left: "25%" }}
              />
            </div>
            <div
              className="colorBox"
              style={{ position: "relative", cursor: "pointer" }}
              onClick={handleButtonClick}
            >
              <img
                src={imagePreview ? imagePreview : "/images/AddBG/plus.svg"}
                alt="addimg"
                style={{
                  position: "absolute",
                  top: imagePreview ? 0 : "25%",
                  left: imagePreview ? 0 : "25%",
                  width: imagePreview ? "100%" : "",
                }}
              />
              {imagePreview ? (
                <button onClick={handleCancel} className="red-cancel">
                  &times;
                </button>
              ) : (
                ""
              )}
              <input
                ref={imgInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                type="file"
                id="fileUpload"
              />
            </div>

            {images?.length &&
              images?.map((img, index) => (
                <div
                  key={index}
                  className={`backgroundBox ${
                    selectedImage === img.name ? "selected" : ""
                  }`}
                  onClick={() => {
                    setSelectedImage(img.name);
                    setSelectedImageURL(img.url);
                  }}
                  style={{
                    cursor: "pointer",
                    boxShadow:
                      selectedImage === img.name
                        ? "0 0 0 3px white, 0 0 0 5px blue"
                        : "",
                  }}
                >
                  <img
                    src={img.url}
                    style={{ width: "65px", height: "65px" }}
                    alt={`bg-${index}`}
                  />
                </div>
              ))}

            {/* Add more backgrounds as needed */}
          </div>
          <div className="popover-buttons">
            <button className="resetButton" onClick={handleReset}>
            {   t('addBackgroundPage.buttons.reset')}
            </button>
            <button className="doneButton" onClick={handleDone}>
            {t('addBackgroundPage.buttons.add')}

            </button>
          </div>
        </PopoverBody>
      </Popover>
    </>
  );
};

export default BackgroundPopover;
